import {io} from 'socket.io-client';


// const socket = io("https://testing.stbs.uk");
const socket = io("https://svsclients.com");

export default socket;

